import { Box, Button, Fade, Grid, Typography } from "@material-ui/core"
import { ErroIcon } from "components/icons/erro-icon"
import { TentarNovamenteIcon } from "components/icons/tentar-novamente-icon"
import React from "react"
import { EnumOpcoesDelivery } from "storage"
import { useStyles } from "./tipo-pagamento-erro-styles"
import { useThemeQueries } from "components/dialogs/dialog-adicionar-produto-com-subitem/util-styles"
import { OkIcon } from "utils/Icons/ok-icon"

interface TipoPagamentoErroProps {
    msgErro: string | undefined
    clickPix: () => void
    clickFinalizar: () => void
    handleCancelarPedido: () => void
    tipoDelivery: EnumOpcoesDelivery | undefined
}

export const TipoPagamentoErro = ({ msgErro, clickPix, clickFinalizar, handleCancelarPedido, tipoDelivery }: TipoPagamentoErroProps) => {

    const classes = useStyles()
    const { theme } = useThemeQueries()

    return (
        <Fade in>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box textAlign={"center"}>
                        <Typography>
                            Ops. Ocorreu um problema ao iniciar o pagamento pelo PIX. Gostaria de tentar novamente?
                        </Typography>
                        {msgErro && (
                            <Typography>
                                Detalhe: {msgErro}
                            </Typography>
                        )}
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        size="large"
                        onClick={clickPix}
                        className={classes.espacamento}
                    >
                        <TentarNovamenteIcon tipo="BUTTON_PRIMARY" />
                        Tentar novamente
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        size="large"
                        color="primary"
                        variant="contained"
                        fullWidth
                        className={classes.espacamento}
                        onClick={clickFinalizar}
                    >
                        <OkIcon tipo="BUTTON_PRIMARY" />
                        {(tipoDelivery && tipoDelivery !== EnumOpcoesDelivery.Retirada ? "Pagar na Entrega" : 'Pagar na Retirada')}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        size="large"
                        variant="outlined"
                        color={
                            theme.palette.type === "light"
                                ? "primary"
                                : "inherit"
                        }
                        fullWidth
                        onClick={handleCancelarPedido}
                    >
                        <ErroIcon tipo={theme.palette.type === "light" ? 'BUTTON' : 'BUTTON_PRIMARY'} />
                        Cancelar pedido
                    </Button>
                </Grid>
            </Grid>
        </Fade>
    )
}